import AsyncStorage from './AsyncStorage';
export { useAsyncStorage } from './hooks';
export default AsyncStorage; // @ts-ignore AsyncStorage mock module
//# sourceMappingURL=index.js.map